import React, { useState, useEffect } from 'react';
import { Accordion } from 'react-bootstrap';
import classes from './AccordioWrapper.module.css';

const AccordionWrapper = ({ className, children, show }) => {
  const [activeKeys, setActiveKeys] = useState(null);
  useEffect(() => {
    if (show === false) {
      setActiveKeys(null);
    }
  }, [show]);


  return (
    <Accordion
      activeKey={activeKeys}
      onSelect={(key) => setActiveKeys(key)}
      className={className}
      // defaultActiveKey={['-1']}
      alwaysOpen>
      {children}
    </Accordion>
  );
};

export default AccordionWrapper;
